import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "paginador",
  templateUrl: "./paginador.component.html",
  styleUrls: ["./paginador.component.scss"],
})
export class PaginadorComponent {
  @Input() currentPage: number = null;
  @Input() listedPages: number[];
  @Input() firstItemOnPage: number = null;
  @Input() lastItemOnPage: number = null;
  @Input() totalPages: number = null;
  @Input() totalItems: number = null;
  @Input() itemsPerPage: any[];

  @Output() onSearch: EventEmitter<any> = new EventEmitter();

  faAngleDoubleLeft = faAngleDoubleLeft;
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleRight = faAngleRight;
  faAngleLeft = faAngleLeft;

  constructor(private cookieService: CookieService) {}

  pageSizeCookie: String = this.cookieService.get("pageSize");
  @Output() pageSize: number =
    this.pageSizeCookie != null && this.pageSizeCookie != ""
      ? Number(this.pageSizeCookie)
      : 10;

  onSearchEvent(currentPage: number) {
    this.cookieService.set("pageSize", this.pageSize.toString());

    this.onSearch.emit([currentPage, this.pageSize]);
  }
}
